import { type FC } from "react";
import { Box, CircularProgress, Dialog } from "@mui/material";
import { useStreamEntrypointQuery } from "@/partner/entities/streamEntrypoints";
import type { StreamEntrypointTab } from "../model";
import { StreamEntrypointForm } from "./StreamEntrypointForm";

interface StreamEntrypointDialogProps {
  open: boolean;
  id: string | null;
  tab: StreamEntrypointTab;
  onClose: () => void;
}

// По образцу EditStreamDialog.tsx (streams-фича): fullScreen-диалог,
// подгружает точку по id и делегирует рендер формы StreamEntrypointForm.
export const StreamEntrypointDialog: FC<StreamEntrypointDialogProps> = ({
  open,
  id,
  tab,
  onClose,
}) => {
  const { data, loading } = useStreamEntrypointQuery({
    variables: { id: id ?? "" },
    skip: !id || !open,
    // liveConnected changes server-side without a local mutation — poll
    // while the dialog is open; skip above keeps this from polling in the
    // background once it's closed.
    pollInterval: 15000,
  });

  const entrypoint = data?.streamEntrypoint;

  return (
    <Dialog open={open} onClose={onClose} fullScreen>
      {loading && !data ? (
        <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
          <CircularProgress />
        </Box>
      ) : entrypoint ? (
        <StreamEntrypointForm
          entrypoint={entrypoint}
          tab={tab}
          onClose={onClose}
        />
      ) : null}
    </Dialog>
  );
};
